<template>
  <div class="wrapper pt-6">
    <v-btn class="align-self-end mb-12" large @click="logout">Log out</v-btn>

    <v-data-table
      :headers="headers"
      :items="events"
      class="elevation-1 align-self-stretch"
      :items-per-page="30"
    >
      <template v-slot:item.edit="{ item }">
        <v-icon small class="mr-2" @click="editEvent(item)">mdi-pencil</v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500px">
      <div class="white pa-5" v-if="selectedEvent">
        <h1 class="title mb-4">
          <span class="mr-2">Event:</span>
          <span class="body-1">{{selectedEvent.name}}</span>
        </h1>

        <v-menu
          v-model="startDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          class="mb-4"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDateFormatted"
              label="Start Date"
              persistent-hint
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" no-title @input="startDatePicker = false"></v-date-picker>
        </v-menu>

        <v-menu
          v-model="endDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          class="mb-4"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDateFormatted"
              label="End Date"
              persistent-hint
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" no-title @input="endDatePicker = false"></v-date-picker>
        </v-menu>

        <v-btn large class="mx-auto d-block" @click="save" :loading="loading">Save</v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
var moment = require("moment");

export default {
  data: () => ({
    loading: false,
    startDatePicker: false,
    endDatePicker: false,
    startDate: null,
    endDate: null,
    dialog: false,
    selectedEvent: null,
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name"
      },
      {
        text: "Address",
        align: "start",
        sortable: false,
        value: "address"
      },
      {
        text: "Start Date",
        align: "start",
        sortable: false,
        value: "startDate"
      },
      {
        text: "End Date",
        align: "start",
        sortable: false,
        value: "endDate"
      },
      { text: "Edit", value: "edit", sortable: false }
    ],
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    }
  }),

  computed: {
    ...mapState({
      events: state => state.events
    }),
    startDateFormatted() {
      if (!this.startDate) return;
      return moment(this.startDate).format("MM/DD/YYYY");
    },
    endDateFormatted() {
      if (!this.endDate) return;
      return moment(this.endDate).format("MM/DD/YYYY");
    }
  },
  methods: {
    ...mapActions(["logout", "updateEvent"]),
    editEvent(event) {
      this.dialog = true;
      this.selectedEvent = { ...event };
      this.startDate = new Date(this.selectedEvent.startDate).toISOString();
      this.endDate = new Date(this.selectedEvent.endDate).toISOString();
    },
    save() {
      this.loading = true;
      this.selectedEvent.startDate = this.startDate;
      this.selectedEvent.endDate = this.endDate;
      this.updateEvent(this.selectedEvent)
        .then(() => {
          this.loading = false;
          this.dialog = false;
        })
        .catch(er => {
          console.log(er);
        });
    }
  }
};
</script>


<style lang="scss" scoped>
.wrapper {
  height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>